// import React, { useState } from "react";
// import { Star } from "lucide-react";

// export default function IndustriesGrid({ featured, others, testid = "industries-grid" }) {
//   // 0 = featured (default). Hover any "other" card to preview that industry on the left.
//   const items = [featured, ...others];
//   const [active, setActive] = useState(0);
//   const current = items[active];

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-testid={testid}>
//       {/* Big dark card — content changes on hover */}
//       <div className="lg:col-span-5">
//         <div
//           className="aidify-card-dark p-7 lg:p-9 h-full flex flex-col transition-all duration-500"
//           data-reveal
//           data-testid="industries-featured"
//         >
//           <span className="section-pill !bg-forest-500 !text-cream-100/80 !border-forest-400 self-start inline-flex items-center gap-1.5">
//             <Star size={11} className="text-sage-200" fill="currentColor" />
//             {active === 0 ? "Featured" : "Industry"}
//           </span>

//           {/* keyed wrapper so React fades the content on switch */}
//           <div key={active} className="flex-1 flex flex-col animate-fade-up">
//             <h3 className="mt-6 font-display font-extrabold text-3xl md:text-4xl leading-tight text-cream-100">
//               {current.title}
//             </h3>
//             <p className="mt-5 text-cream-100/75 leading-relaxed text-[15px] flex-1">
//               {current.description}
//             </p>
//           </div>

//           {/* <p className="mt-8 text-xs uppercase tracking-[0.2em] text-cream-100/50">
//             Hover any industry →
//           </p> */}
//         </div>
//       </div>

//       {/* Other industries grid */}
//       <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-3 self-start">
//         {others.map((it, i) => {
//           const idx = i + 1;
//           const isActive = active === idx;
//           return (
//             // <button
//             //   key={i}
//             //   type="button"
//             //   onMouseEnter={() => setActive(idx)}
//             //   onFocus={() => setActive(idx)}
//             //   data-testid={`industry-${i}`}
//             //   data-reveal
//             //   data-i={(i % 6) + 1}
//             //   // className={`aidify-card text-left p-5 transition-all duration-300 ${
//             //   //   isActive ? "bg-sage-200 border-sage-300" : ""
//             //   // }`}
//             //   // We add 'bg-white' as a base so it's always visible 
//             //   // and 'shadow-sm' to keep it distinct from the page background.
//             //   className={`aidify-card bg-white border border-transparent text-left p-5 transition-all duration-300 shadow-sm ${
//             //     isActive ? "bg-sage-50 border-sage-200 shadow-md scale-[1.02]" : "hover:border-sage-100"
//             //   }`}
//             // >
//             <button
//               key={i}
//               type="button"
//               onMouseEnter={() => setActive(idx)}
//               onFocus={() => setActive(idx)}
//               data-testid={`industry-${i}`}
//               // REMOVE data-reveal and data-i from here
//               className={`aidify-card bg-white text-left p-5 transition-all duration-300 border ${
//                 isActive 
//                   ? "bg-sage-50 border-sage-300 shadow-md ring-1 ring-sage-300" 
//                   : "border-transparent hover:border-sage-100"
//               }`}
//             >
              
//               <div className="flex items-center justify-between mb-2">
//                 <span
//                   className={`w-7 h-7 rounded-full transition-colors duration-300 ${
//                     isActive ? "bg-forest-600" : "bg-cream-200"
//                   }`}
//                 />
//                 <span className={`text-xs uppercase tracking-wider transition-colors ${isActive ? "text-forest-600" : "text-forest-400/60"}`}>
//                   ▾
//                 </span>
//               </div>
//               <h4 className="font-display font-bold text-base text-forest-600">{it.title}</h4>
//               <p className="mt-1.5 text-xs text-forest-400 line-clamp-2 leading-relaxed">
//                 {it.description}
//               </p>
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import { Star } from "lucide-react";

export default function IndustriesGrid({ featured, others, testid = "industries-grid" }) {
  // 0 = featured (default). Clicking any "other" card previews that industry on the left.
  const items = [featured, ...others];
  const [active, setActive] = useState(0);
  const current = items[active];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-testid={testid}>
      {/* Big dark card — content changes on click */}
      <div className="lg:col-span-5">
        <div
          className="aidify-card-dark p-7 lg:p-9 h-full flex flex-col transition-all duration-500"
          data-reveal
          data-testid="industries-featured"
        >
          <span className="section-pill !bg-forest-500 !text-cream-100/80 !border-forest-400 self-start inline-flex items-center gap-1.5">
            <Star size={11} className="text-sage-200" fill="currentColor" />
            {active === 0 ? "Featured" : "Industry"}
          </span>

          {/* keyed wrapper so React fades the content on switch */}
          <div key={active} className="flex-1 flex flex-col animate-fade-up">
            <h3 className="mt-6 font-display font-extrabold text-3xl md:text-4xl leading-tight text-cream-100">
              {current.title}
            </h3>
            <p className="mt-5 text-cream-100/75 leading-relaxed text-[15px] flex-1">
              {current.description}
            </p>
          </div>
        </div>
      </div>

      {/* Other industries grid */}
      <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-3 self-start">
        {others.map((it, i) => {
          const idx = i + 1;
          const isActive = active === idx;
          return (
            <button
              key={i}
              type="button"
              onClick={() => setActive(idx)} // Changed from onMouseEnter to onClick
              onFocus={() => setActive(idx)}
              data-testid={`industry-${i}`}
              className={`aidify-card bg-white text-left p-5 transition-all duration-300 border cursor-pointer ${
                isActive 
                  ? "bg-sage-50 border-sage-300 shadow-md ring-1 ring-sage-300" 
                  : "border-transparent" // Removed hover:border-sage-100
              }`}
            >
              <div className="flex items-center justify-between mb-2">
                <span
                  className={`w-7 h-7 rounded-full transition-colors duration-300 ${
                    isActive ? "bg-forest-600" : "bg-cream-200"
                  }`}
                />
                <span className={`text-xs uppercase tracking-wider transition-colors ${isActive ? "text-forest-600" : "text-forest-400/60"}`}>
                  ▾
                </span>
              </div>
              <h4 className="font-display font-bold text-base text-forest-600">{it.title}</h4>
              <p className="mt-1.5 text-xs text-forest-400 line-clamp-2 leading-relaxed">
                {it.description}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
